import { useQuery } from '@apollo/client';
import { InstalledBaseNodeNetworkScanUser } from '../graphql/queries/installedBaseNodeNetworkScanUser';
import { isSlaEnabled } from '../utils/slaEnabled';

/**
 * Name of the user who documented the network scan on `sourceNodeId`
 * (IBM-1039) — the lookup behind "Documented by" for effective / inherited
 * scans, whose `EffectiveNetworkScan` carries no `userName`. Null while
 * loading, when nobody is recorded, or when the source node is not readable
 * for the user (the effective scan's source is shown regardless of access).
 */
export const useNetworkScanUserName = (sourceNodeId?: string | null, skip?: boolean): string | null => {
    const query = useQuery(InstalledBaseNodeNetworkScanUser, {
        variables: { id: sourceNodeId },
        skip: !sourceNodeId || !!skip || !isSlaEnabled(),
        fetchPolicy: 'cache-first',
        errorPolicy: 'all',
    });
    return query.data?.installedBaseNode?.networkScan?.userName ?? null;
};
